import type { Sheet } from '../../domain/Sheet';
import type { SheetCloseEvent } from '$services/tracking/TrackingPayload';
import { ContractType } from '../../domain/Contract';

export const internalErrorSheet = (closeCallback?: (event: SheetCloseEvent) => void): Sheet => {
	return {
		title: 'Entschuldige, das hat leider nicht geklappt.',
		url: '/up-homeui/sheet/error/unknown',
		lockMobileHeight: false,
		initialMobileHeight: '58vh',
		showBackButton: false,
		fullBleedContent: true,
		closeCallback: closeCallback
	};
};

export const birthdayRaffleGoodbyeSheet = (): Sheet => {
	return {
		title: ' ',
		url: `/up-homeui/sheet/raffle/goodbye`,
		lockMobileHeight: true,
		showBackButton: false,
		fullBleedContent: true,
		initialMobileHeight: '40vh',
		menuContent: '<button type="button" class="pl_button100--primary" onclick="o_global.pali.sheet.getActiveSheet().close()"><span>Schließen</span></button>'
	};
};

export const employeeTutorialSheetProps = () => {
	return {
		id: 'employee-tutorial-sheet',
		headline: 'Herzlich willkommen bei OTTO UP!',
		url: '/up-homeui/sheet/employee-tutorial',
		noContentPadding: true,
		fullHeight: true
	};
};

export const instructionSheet = (achievementId: string, sheetId: string = 'instructions-sheet') => {
	return {
		headline: 'Challenge',
		url: `/up-homeui/sheet/achievement/instructions?achievementId=${achievementId}`,
		noContentPadding: true,
		hideHeader: true,
		id: sheetId
	};
};

export const comingSoonSheet = (achievementId: string = '') => {
	return {
		headline: 'Next Challenge',
		url: `/up-homeui/sheet/achievement/coming-soon?achievementId=${achievementId}`,
		noContentPadding: true,
		hideHeader: true
	};
};

export const collectedCardSheet = (compensationAmount: number, showFeedback: boolean = false, achievementName: string = '', achievementId: string = '') => {
	const queryParameters = showFeedback ? `&showFeedback=true&achievementName=${achievementName}&achievementId=${achievementId}` : '';
	return {
		url: `/up-homeui/sheet/achievement/collected?compensationAmount=${compensationAmount}${queryParameters}`,
		fullHeight: true,
		initialMobileHeight: '95vh',
		noContentPadding: true,
		hideHeader: true
	};
};

export const expiredCardSheet = (showFeedback: boolean = false, achievementName: string = '', achievementId: string = '') => {
	const queryParameters = showFeedback ? `?showFeedback=true&achievementName=${achievementName}&achievementId=${achievementId}` : '';
	return {
		url: `/up-homeui/sheet/achievement/expired${queryParameters}`,
		fullHeight: true,
		initialMobileHeight: '95vh',
		noContentPadding: true,
		hideHeader: true
	};
};

export const prebookedPointsSheet = () => {
	return {
		headline: 'UP hier sammelst du Punkte',
		url: `/up-homeui/sheet/prebooked-points`,
		noContentPadding: false
	};
};

export const thirdTutorialSheet = () => {
	return {
		id: 'tutorial-3',
		url: '/up-homeui/sheet/achievement/tutorial/third',
		hideHeader: true,
		noContentPadding: true
	};
};

export const termsAndConditionsSheet = (id: string) => {
	return {
		id: id,
		headline: 'OTTO UP Teilnahmebedingungen',
		url: '/up-homeui/sheet/terms-and-conditions',
		fullHeight: true,
		noContentPadding: true
	};
};

export const achievementSecondTutorialSheet = () => {
	return {
		id: 'tutorial-2',
		url: '/up-homeui/sheet/achievement/tutorial/second',
		hideHeader: true,
		noContentPadding: true
	};
};

export const newMechanismCommunicationSheet = () => {
	return {
		id: 'communication',
		url: '/up-homeui/sheet/achievement/communication',
		hideHeader: true,
		noContentPadding: true
	};
};

export const myBenefitsSheet = () => {
	return {
		id: 'my-benefits-sheet',
		headline: 'Punkte sammeln und einlösen',
		url: '/up-homeui/sheet/my-benefits',
		noContentPadding: true
	};
};

export const tutorialSheet = () => {
	return {
		id: 'employee-tutorial-sheet',
		headline: 'Herzlich willkommen bei OTTO UP!',
		url: '/up-homeui/sheet/employee-tutorial',
		noContentPadding: true,
		fullHeight: true
	};
};

export const cancellableByCustomerSheet = (contractType: ContractType) => {
	return {
		id: 'up_benefits_sheet',
		headline: contractType === ContractType.PLUS ? 'OTTO UP Plus Mitgliedschaft' : 'OTTO UP Mitgliedschaft',
		url: `/up-homeui/sheet/cancel?contract=${contractType}`,
		noContentPadding: true
	};
};

export const exceedsNoticePeriodSheet = (validTo: string | null) => {
	return {
		id: 'up_non_cancellable_sheet',
		headline: 'Deine Mitgliedschaft',
		url: `/up-homeui/sheet/cancel/exceeds-period?validTo=${validTo}`,
		noContentPadding: true
	};
};


export const nextPointsExpirationSheet = () => {
	return {
		headline: 'UP hier Chance nutzen',
		url: `/up-homeui/sheet/next-points-expiration`
	};
};

export const sponsoredSheet = (id: string) => {
	return {
		headline: 'Warum sehe ich diese Seite?',
		url: `/up-homeui/sheet/achievement/sponsored?achievementId=${id}`,
		fullHeight: true,
		noContentPadding: true
	};
};
